import { useContext, useEffect } from 'react';
import AppSettingsContext from '../../contexts/AppSettingsContext';
import initializeSentry from '../../utils/initializeSentry';

const useSentryInitializer = () => {
    const appSettingsResponse = useContext(AppSettingsContext);
    const sentrySettings = appSettingsResponse?.data?.sentrySettings;

    useEffect(() => {
        if (sentrySettings) {
            // No-op if Sentry is already initialized (e.g. pre-render init in main.tsx).
            // Acts as a fallback for the first render in case window.APPSETTINGS
            // did not contain sentrySettings when the page loaded.
            initializeSentry(sentrySettings);
        }
    }, [sentrySettings]);
};

export default useSentryInitializer;
